import React from "react";
import CertificationDashboard from "./CertificationDashboard";

const QNGDashboard = () => {
  const reportID = "9f67ca9e-4de1-11f0-aa66-db6e7cf86b95";
  return <CertificationDashboard reportID={reportID} />;
};

export default QNGDashboard;
